module.exports = __webpack_public_path__ + "img/icon-asc.9fd5d1cf.svg";